import { render, staticRenderFns } from "./MobilePreview.vue?vue&type=template&id=58deb330"
import script from "./MobilePreview.vue?vue&type=script&lang=js"
export * from "./MobilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports